import type { AdminAccount } from '@inflip/contracts/admin';
import { Link } from '@tanstack/react-router';
import { useEffect, useState } from 'react';

import { api } from '../lib/api-client';
import { useAdminAuth } from '../lib/auth-context';

/** 콘텐츠 영역 상단 헤더 — 도움말(가이드) 버튼 + 내 계정 아바타. */
export function AdminTopbar() {
  const { session } = useAdminAuth();
  const [me, setMe] = useState<AdminAccount | null>(null);

  useEffect(() => {
    if (!session) return;
    let cancelled = false;
    api
      .me(session.accessToken)
      .then((account) => !cancelled && setMe(account))
      .catch(() => {}); // 헤더는 장식 — 실패해도 화면을 막지 않는다
    return () => {
      cancelled = true;
    };
  }, [session]);

  return (
    <header className="flex h-14 items-center justify-end gap-1.5 border-b border-border bg-background px-6">
      <Link
        to="/guide"
        className="flex items-center gap-1.5 rounded-md px-3 py-1.5 text-sm font-medium text-muted-foreground transition hover:bg-muted hover:text-foreground"
      >
        <span aria-hidden>📖</span> 도움말
      </Link>
      <Link
        to="/me"
        className="flex items-center gap-2 rounded-md px-2 py-1.5 transition hover:bg-muted"
        title="내 정보"
      >
        <span className="grid h-8 w-8 place-items-center rounded-full bg-brand text-sm font-bold text-white">
          {(me?.name ?? '?').slice(0, 1)}
        </span>
        <span className="hidden text-sm font-semibold sm:block">
          {me?.name ?? ''}
          {me && (
            <span className="ml-1.5 text-[10px] font-bold uppercase text-muted-foreground">
              {me.role === 'SUPER_ADMIN' ? 'SUPER' : 'ADMIN'}
            </span>
          )}
        </span>
      </Link>
    </header>
  );
}
